/* eslint-disable no-unreachable */
export function makeEventData (data) {
  let eventData = data.map(function(element) {
    return {
      id: element.id,
      title: element.title,
      start: element.start_time ? new Date(element.start_date + ' ' + element.start_time) : element.start_date,
      end: element.end_time ? new Date(element.end_date + ' ' + element.end_time) : new Date(element.end_date + ' ' + '24:00:00'),
      extendedProps: {
        description: element.description,
      },
      // backgroundColor: 'var(--theme-primary-color, #1b55e3)',
      // borderColor: 'var(--theme-primary-color, #1b55e3)',
      backgroundColor: getColor(element.in_attendance),
      borderColor: getColor(element.in_attendance),
    }
  })
  return eventData
}

function getColor(inAttendance) {
  if (!inAttendance) {
    return '#fb434a'
  } else {
    return '#1b55e3'
  }
}
